import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ds-empty-state',
  standalone: false,
  template: `
    <div class="ds-empty-state">
      <div class="ds-empty-state-icon">
        <i class="bi" [ngClass]="icon"></i>
      </div>
      <h3 class="ds-empty-state-title">{{ title }}</h3>
      <p class="ds-empty-state-description">{{ description }}</p>
      <ng-content></ng-content>
    </div>
  `,
})
export class DsEmptyState {
  @Input() title = 'Nothing to show';
  @Input() description = '';
  @Input() icon = 'bi-inbox';
}
